// extracted by mini-css-extract-plugin
export default {"statsContainer":"stats_statsContainer__GBOFF","stat":"stats_stat__N1g41","icon":"stats_icon__Dkeh6"};